import { Reporti18nInstance } from '../i18n/configs';

type TranslateParams = {
  [key: string]: string | number;
};

export function translate(key: string, params?: TranslateParams) {
  return params ? Reporti18nInstance.t(key, params) : Reporti18nInstance.t(key);
}
